import $ from 'jquery';
import View from 'cdna/core/view';
import markup from './faqEntryView.html';

export default View.extend({
    el: markup,
    bindings: {
        'Name': 'attr name',
        'Title .toggler span': 'text',
        'Html': {
            changeElement(el, val, binding) {
                binding.view.$('.faq').remove();
                if (!val) return;

                var target = binding.view.$('.toggler');
                $('<div>')
                    .addClass('faq')
                    .html(val)
                    .insertAfter(target);
            }
        },
        'toggled .toggler': {
            changeElement(el, val) {
                if (val) el.addClass('active').removeClass('inactive');
                else el.addClass('inactive').removeClass('active');
            }
        },
        'toggled .faq': 'visibility'
    },
    events: {
        'click .toggler': 'toggleVisibility'
    },
    toggleVisibility() {
        this.model.set('toggled', !this.model.get('toggled'));
    }
});



/** WEBPACK FOOTER **
 ** ./client/faq/faqEntryView.js
 **/